import { AffinisCellTemplateKey, AffinisHeaderColumn } from '../data-table.enums';
import { MtxGridColumn } from '@ng-matero/extensions/grid';

export interface AffinisGridColumn extends MtxGridColumn {
  cellTemplateKey?: AffinisCellTemplateKey;
  headerType?: AffinisHeaderColumn;
  required?: boolean;
  dependantSelect?: boolean;
  dependantSelectAttribute?: string;
}
